var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 8.63636,
    stroke: "#979797",
    strokeWidth: 0.727273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3381 12.9268L9.92792 11.125H8.06757L7.65741 12.9268H6.32929L8.09687 5.75879H9.89863L11.6711 12.9268H10.3381ZM9.6789 9.94824L9.29804 8.28809C9.27525 8.18717 9.22317 7.9349 9.14179 7.53125C9.06366 7.12435 9.01646 6.85254 9.00019 6.71582C8.95787 6.99577 8.90416 7.30501 8.83906 7.64355C8.77395 7.97884 8.60468 8.74707 8.33124 9.94824H9.6789Z",
    fill: "#979797"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.21086c29e2af9d5bb4f5beec345f6a8a.svg";
export { ForwardRef as ReactComponent };